<template>
	<div class="application-page career">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation page="career"/>
				</b-col>
				<b-col md="9">
					<h1>Mein Lebenslauf</h1>
					<div class="main-content">
						<Career
							v-model="career"
							:class="{ 'loading-blockade': saving }"
							:section-completions="sectionCompletions"
							:vita-info="vitaInfo"
							@input="save"
						/>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Navigation from "@/vue/application/profile/Navigation";
import Career from "@/vue/application/Career";
import Button from "@/vue/common/Button";
import {isDefined} from "@/helper/Value";
import ApplicationSkillsSave from "@/api/application/skills/Save";
import {prepareCareer} from "@/helper/application/Preparation";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import * as Log from "@/helper/Log";

export default {
	components: {
		Button,
		Career,
		Navigation
	},

	props: {
		applicationData64: {
			type: String,
			required: true,
		},
		vitaInfo64: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		let applicationData = undefined;

		if (this.applicationData64)
		{
			applicationData = JSON.parse(
				window.atob(this.applicationData64)
			);
		}

		return {
			vitaInfo: JSON.parse(
				window.atob(this.vitaInfo64)
			),
			career: applicationData?.career,
			sectionCompletions: applicationData?.sectionCompletions || [],
			saving: false,
		};
	},

	computed: {
		valid ()
		{
			return isDefined(this.career);
		},
	},

	methods: {
		async save ()
		{
			if (this.saving)
			{
				return;
			}

			this.saving = true;

			try
			{
				const response = await new ApplicationSkillsSave()
					.setData({
						career: {
							careers: this.career
								? prepareCareer(this.career.careers)
								: [],
							educationFinished: this.career.educationFinished,
							careerFinished: this.career.careerFinished,
						}
					})
					.call();

				this.vitaInfo = response.data.vitaInfo;

				Toast.success(this, ['Lebenslauf erfolgreich gespeichert']);
			}
			catch (e)
			{
				Log.error(e);

				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		}
	}
}
</script>
